var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParaplanningSalaries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2586 6.91379V4.86552C26.2586 4.11136 25.5394 3.5 24.6521 3.5H5.10649C4.21925 3.5 3.5 4.11136 3.5 4.86552V29.4448C3.5 30.199 4.21925 30.8103 5.10649 30.8103H8.05172",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0862 23.9828V8.27934C33.0862 7.52518 32.4749 6.91382 31.7207 6.91382H9.41727C8.66312 6.91382 8.05176 7.52518 8.05176 8.27934V32.8586C8.05176 33.6128 8.66312 34.2242 9.41727 34.2242H24.5518",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6034 20.569H25.1206",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6034 16.0172H28.5344",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6034 11.4656H28.5344",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6034 25.1207H20.5689",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6034 29.6724H18.293",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6724 36.5C33.4432 36.5 36.5 33.4432 36.5 29.6724C36.5 25.9017 33.4432 22.8448 29.6724 22.8448C25.9017 22.8448 22.8448 25.9017 22.8448 29.6724C22.8448 33.4432 25.9017 36.5 29.6724 36.5Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4431 32.5H27.5909V31.875H31.4431V32.5ZM30.2159 30.2386H27.5681V29.5909H30.2159V30.2386ZM28.8068 28.4432L28.8977 30.9091C28.909 31.1477 28.8873 31.3684 28.8323 31.571C28.7793 31.7718 28.6761 31.9261 28.5227 32.0341L27.8181 31.875C27.9318 31.875 28.0189 31.8182 28.0795 31.7045C28.1401 31.5909 28.1808 31.4583 28.2017 31.3068C28.2225 31.1553 28.231 31.0227 28.2272 30.9091L28.1477 28.4432C28.1325 28.0303 28.2073 27.6875 28.3721 27.4148C28.5388 27.142 28.7566 26.9384 29.0255 26.804C29.2964 26.6695 29.5795 26.6023 29.875 26.6023C30.1458 26.6023 30.392 26.6515 30.6136 26.75C30.8352 26.8466 31.0217 26.9773 31.1732 27.142C31.3248 27.3068 31.4308 27.4924 31.4914 27.6989C31.552 27.9034 31.5549 28.1136 31.5 28.3295L30.8409 28.1477C30.8674 27.9508 30.8371 27.7841 30.75 27.6477C30.6647 27.5095 30.5454 27.4053 30.392 27.3352C30.2405 27.2633 30.0795 27.2273 29.909 27.2273C29.7272 27.2273 29.552 27.2708 29.3835 27.358C29.2149 27.4432 29.0767 27.5758 28.9687 27.7557C28.8607 27.9337 28.8068 28.1629 28.8068 28.4432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParaplanningSalaries);
export default __webpack_public_path__ + "static/media/ParaplanningSalaries.18270394462550b7ba4f12e83c3202e8.svg";
export { ForwardRef as ReactComponent };